import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { OrbBoardBaseComponent } from '../org-board-base-component';
import { Position } from '../services/org-board-builder.service';
import { OrgBoardService } from '../services/org-board-service';
import { CommonModule, NgStyle } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { ECONode } from '@newgenus/common';

@Component({
    selector: 'shared-sidebar-position-detail',
    imports: [CommonModule, MaterialModule, NgStyle, FormsModule],
    template: `
        <!-- Org Part Details (dev-only) -->
        <mat-card class="my-2" *ngIf="isDev">
            <!-- Org Part title. -->
            <mat-card-header
                class="collapsible-header"
                style="cursor: pointer;"
                (click)="sectionExpanded = !sectionExpanded"
            >
                <mat-card-title>Org Part Details</mat-card-title>
                <mat-card-subtitle>{{ node?.data?.name || '-None-' }}</mat-card-subtitle>
                <mat-icon style="margin-left: auto;">{{ sectionExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </mat-card-header>

            <!-- Position Detail. -->
            <mat-card-content class="pt-2" *ngIf="sectionExpanded">
                <!-- VFP Section -->
                <div style="margin-bottom: 12px;">
                    <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                        <mat-icon style="color: #ffd54f; font-size: 18px; width: 18px; height: 18px;"
                            >emoji_events</mat-icon
                        >
                        <span style="font-weight: 600; font-size: 13px;">Valuable Final Product</span>
                    </div>
                    <div *ngIf="!isEditingVfp">
                        <p
                            *ngIf="$any(node?.data)?.vfp"
                            style="margin: 0 0 8px; font-size: 13px; line-height: 1.5; font-weight: 700; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;"
                        >
                            {{ $any(node?.data)?.vfp }}
                        </p>
                        <p
                            *ngIf="!$any(node?.data)?.vfp"
                            style="margin: 0 0 8px; font-style: italic; opacity: 0.5; font-size: 13px;"
                        >
                            No VFP defined.
                        </p>
                        <div *ngIf="isEditing" style="display: flex; justify-content: flex-end;">
                            <button
                                mat-stroked-button
                                style="font-size: 12px; height: 28px; line-height: 28px;"
                                (click)="startEditingVfp()"
                            >
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px;"
                                    >edit</mat-icon
                                >
                                {{ $any(node?.data)?.vfp ? 'Edit' : 'Add VFP' }}
                            </button>
                        </div>
                    </div>
                    <div *ngIf="isEditingVfp">
                        <textarea
                            #vfpDetailInput
                            style="width: 100%; min-height: 80px; margin-bottom: 6px; outline: none; background: rgba(0,0,0,0.15); border: 1px solid rgba(255,255,255,0.2); border-radius: 6px; color: inherit; font-size: 13px; padding: 10px; resize: vertical; font-family: inherit; line-height: 1.5; box-sizing: border-box;"
                            [value]="$any(node?.data)?.vfp || ''"
                            placeholder="Describe the VFP..."
                        ></textarea>
                        <div style="display: flex; gap: 6px; justify-content: flex-end;">
                            <button
                                mat-stroked-button
                                style="font-size: 12px; height: 28px; line-height: 28px;"
                                (click)="cancelEditingVfp()"
                            >
                                Cancel
                            </button>
                            <button
                                mat-flat-button
                                color="primary"
                                style="font-size: 12px; height: 28px; line-height: 28px;"
                                (click)="saveVfp(vfpDetailInput.value)"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                    <mat-divider style="margin-top: 12px;"></mat-divider>
                </div>

                <div class="description-list-container">
                    <dl>
                        <ng-container *ngIf="isDev">
                            <dt>PartKey:</dt>
                            <dd>{{ node?.data?.partKey || '-None-' }}</dd>
                            <dt>Parent:</dt>
                            <dd>{{ node?.data?.parent || '-None-' }}</dd>
                            <dt>Depth:</dt>
                            <dd>{{ node?.data?.depth || '-None-' }}</dd>
                            <dt>Key:</dt>
                            <dd>{{ node?.data?.key || '-None-' }}</dd>
                            <dt>ID:</dt>
                            <dd>{{ node?.data?.id || '-None-' }}</dd>
                            <dt>Path:</dt>
                            <dd>{{ node?.data?.path || '-None-' }}</dd>
                        </ng-container>

                        <dt>Colours:</dt>
                        <dd class="flex-between">
                            Base: {{ node?.data?.colour?.color || '-Unset-' }}
                            <input
                                type="color"
                                (ngModelChange)="obService.onColourChange.next(node)"
                                [(ngModel)]="nodeColour.color"
                            />
                        </dd>
                        <dd class="flex-between">
                            Background: {{ node?.data?.colour?.background || '-Unset-' }}
                            <input
                                type="color"
                                (ngModelChange)="obService.onColourChange.next(node)"
                                [(ngModel)]="nodeColour.background"
                            />
                        </dd>
                        <dd class="flex-between">
                            Links: {{ node?.data?.colour?.linkColor || '-Unset-' }}
                            <input
                                type="color"
                                (ngModelChange)="obService.onColourChange.next(node)"
                                [(ngModel)]="nodeColour.linkColor"
                            />
                        </dd>
                    </dl>
                </div>
            </mat-card-content>

            <!-- Position Actions -->
            <mat-card-actions align="end" class="button-margin" *ngIf="sectionExpanded">
                <!-- <button mat-button color="primary">BUTTON</button> -->
                <button
                    mat-stroked-button
                    color="primary"
                    (click)="dialogService.openNewHatDialog(node, undefined, undefined, 1)"
                >
                    <mat-icon>add_circle</mat-icon>Assign Hat
                </button>
                <button mat-raised-button color="primary" (click)="dialogService.openNewHatDialog(node)">
                    <mat-icon>add</mat-icon>New Hat
                </button>
                <!-- <button mat-stroked-button color="primary">BUTTON</button> -->
                <!-- <button mat-flat-button color="warn">BUTTON</button> -->
            </mat-card-actions>
        </mat-card>
    `,
    styleUrls: ['../organization-board.component.scss'],
})
export class SidebarPositionDetailComponent extends OrbBoardBaseComponent {
    @Input()
    public isDev = false;

    @Input() // TODO: this should come from the Org doc, and be linked to a UID. Only the matching UID should be allowed to edit?
    public isEditing = false;

    @Input()
    public node!: ECONode<Position>;

    @Output()
    public changeNodeColour = new EventEmitter<ECONode<Position>>();

    public obService = inject(OrgBoardService);

    public isEditingVfp = false;

    /** Collapsed by default — expanded only when explicitly opened. */
    public sectionExpanded = false;

    public get nodeColour() {
        if (!this.node || !this.node.data) {
            return {} as any;
        }

        if (!this.node.data || !this.node.data.colour) {
            this.node.data.colour = { color: '#000000', background: '#FFFFFF', linkColor: '#000000' };
        }

        return this.node.data?.colour;
    }

    // ═══ VFP editing methods ═══

    @ViewChild('vfpDetailInput') vfpDetailInputRef!: ElementRef<HTMLTextAreaElement>;

    public startEditingVfp(): void {
        this.isEditingVfp = true;
        setTimeout(() => {
            const el = this.vfpDetailInputRef?.nativeElement;
            if (el) {
                el.focus();
                el.selectionStart = el.selectionEnd = el.value.length;
            }
        });
    }

    public cancelEditingVfp(): void {
        this.isEditingVfp = false;
    }

    public async saveVfp(value: string): Promise<void> {
        this.isEditingVfp = false;
        const partKey = this.node?.data?.partKey || (this.node?.data as any)?.key;
        if (!partKey || !this.org) return;

        // Update local state
        (this.node.data as any).vfp = value;

        // Also update orgParts on the org object so it stays in sync
        const orgPart = this.org.orgParts?.find((p) => p.partKey === partKey);
        if (orgPart) {
            orgPart.vfp = value;
        }

        // Save to Firestore via subcollection
        try {
            await this.obService.updatePart({ partKey, vfp: value } as any, this.org, false);
            console.log('[sidebar-position-detail] VFP saved for part:', partKey);
        } catch (error) {
            console.error('[sidebar-position-detail] Failed to save VFP:', error);
        }
    }
}
